import type { NameTables } from './random-creature-name';

export type NameGender = 'all' | 'male' | 'female';
export interface NameToolSelection { name_gender: NameGender; name_type: string }

// The ordinary tool's authored source IDs. Cultural human choices retain the human default.
const sources: Record<string, readonly [string, string, string]> = {
    human: ['F145078C-472C-6095-8799-923202A8BADC', '1919E41C-FB3B-C2FF-E43D-02DD252CF95F', 'B12A5E42-9FE9-B866-A62E-5E6CC446BEB2'],
    dwarf: ['4377C48B-79CE-0C3C-D104-A390E715AEBA', '7280BFDF-8AFE-1853-110C-558A8FF55B6C', 'C408AC11-75F5-4588-4334-82CF60CB07ED'],
    elf: ['A43F63AA-0B43-14F1-3CAA-9C2E7332EC8D', '3BF6186E-59DE-49E3-0EA2-FFB725479C59', '75BBDD7E-7308-8EBA-A45E-D35DCF15AEA5'],
    halfolk: ['A186CAB2-E296-8B52-9BD6-5BDA365FA1C7', 'CBB0DE0F-692D-53BB-FCB2-8254FA68B74C', '89EA4523-9897-3D95-014F-876F04506B77'],
    dragonfolk: ['D4E1CE36-292A-AF5A-888C-FE715208CD33', '3AEED8B1-9DB8-F187-FABD-EA50D12F3E74', '3511FBA6-3C23-3ECF-B574-54789E66EDCD'],
    gnome: ['AE8258F8-B6B9-F247-8CE9-3F4BDD398E15', '00E9375A-97CC-DE1D-E118-64D79A91B89E', '1460760A-87D4-CFAE-8280-A6FB789C3EB0'],
    orc: ['C9904994-CD5D-7E0B-A4AD-9E321A528B4C', 'D8D27719-FC09-68AE-E474-D83C0B4DE301', ''],
    devilfolk: ['A2687BAC-5387-4436-6557-3B23998B3DCC', '6DE0FC3D-8B07-EB97-B600-D3CA096FF6DE', '10B8C2A8-FA2A-DEB1-A6E1-66278E6D7C9B'],
    leprechaun: ['44906914-BA0C-6FB0-2B56-5E09960B7799', 'AE2B59C9-8EED-09AA-35C9-771BB9BB5765', 'F88DA28B-7F12-D564-9DB7-947C5C4D99DE'],
};

export function nameGeneratorTables(selection: NameToolSelection): NameTables {
    if (selection.name_type === 'god') return {
        first: ['106695FB-014C-70CF-0D3F-95EEF7B98D42'], last: '73C4F093-E3B7-99AC-0FA6-9916B3EE80A2',
        domains: ['F3821A29-FFAC-9C61-2D26-AC1F489F911F', '62289D52-FD04-A58F-5CE3-8C83215BFC78'],
        symbol: '7569F432-4B65-9283-3492-201525A3F81E',
    };
    const [male, female, last] = Object.prototype.hasOwnProperty.call(sources, selection.name_type) ? sources[selection.name_type]! : sources.human!;
    return { first: selection.name_gender === 'male' ? [male] : selection.name_gender === 'female' ? [female] : [male, female], last };
}

export function nameGeneratorSourceIds(tables: NameTables): string[] {
    return [...new Set([...tables.first, tables.last, ...(tables.domains ?? []), tables.symbol ?? ''].filter(Boolean))];
}
